<template>
    <b-modal id="importar-itens-licitacao-modal" size="md" centered header-bg-variant="secondary"
        header-text-variant="light" title="Importar itens de planilha" @hidden="$emit('fecharModal')">
        <b-row>
            <b-col cols="12">
                <b-form-group id="arquivo-input-group" label="" label-for="input-arquivo" label-cols="auto">
                    <b-form-file v-model="arquivo" placeholder="Escolha o arquivo"
                        drop-placeholder="Solte o arquivo aqui" class="" browse-text="Escolher" accept=".xlsx"
                        :disabled="showLoading"></b-form-file>
                </b-form-group>
            </b-col>
        </b-row>
        <template v-slot:modal-footer="">
            <b-spinner v-if="showLoading"></b-spinner>
            <btn-download botao :fazerDownload="downloadModelo" :texto="'Baixar o modelo'" :disabled="showLoading" />
            <b-button size="sm" variant="success" @click="enviarArquivo" :disabled="showLoading">
                <font-awesome-icon icon="cloud-upload" />
                Confirmar
            </b-button>
        </template>
    </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ldiService from '@/services/licitacoes/ldiService'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'
import { eventBus } from '@/main'

import BtnDownload from '@/components/shared/btn-download.vue'

const CompProps = Vue.extend({
    name: 'ModalImportarItensLicitacao',
    components: { BtnDownload },
    props: {
        idLicitacao: {
            type: Number,
            required: true
        },
        modo: {
            type: String,
            validator(value: string) {
                return ['item', 'lote', 'dispensa'].includes(value)
            },
            default: 'item'
        }
    }
})

@Component
export default class ModalImportarItensLicitacao extends mixins(UtilsTS, CompProps) {
    arquivo: File | null = null
    showLoading = false

    async mounted() {
        this.$bvModal.show("importar-itens-licitacao-modal");
    }

    async downloadModelo() {
        const responseBlob = await ldiService.baixarModeloImportacaoItem(this.modo === 'lote' ? 'itensLote' : this.modo === 'dispensa' ? 'itensDispensa' : 'itens')
        const nomeArquivo = this.modo === 'dispensa' ? 'modelo-importacao-itens-dispensa' : `modelo-importacao-licitacao-${this.modo}`
        this.download(`${nomeArquivo}.xlsx`, responseBlob)
    }
    async enviarArquivo() {
        this.showLoading = true
        try {
            if (this.arquivo === null) {
                this.$toast.error("O arquivo deve ser informado.")
                return;
            }

            const fd = new FormData()
            fd.append('arquivoItensLote', this.arquivo ? this.arquivo : '')
            const response = await ldiService.importarLotesPlanilha(this.modo, this.idLicitacao, fd)
            // console.log('ModalImportarItensLicitacao.enviarArquivo response', response)
            this.$toast.success(`Foram importados ${response.length} itens.`)
            eventBus.$emit('atualizar-status-licitacao')
            this.$emit('fecharModal', true)
            this.arquivo = null
        } catch (e: any) {
            console.error('Falha ao importar itens de licitação', e.response, e)
            this.tratarError(e)
        } finally {
            this.showLoading = false
        }
    }

}


</script>

<style scoped></style>